import { SVGInterface } from "../../interface";

const CloudOff = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M24 14.0701C24 11.4301 21.95 9.29005 19.35 9.11005C18.67 5.66005 15.64 3.07005 12 3.07005C10.67 3.07005 9.43 3.43005 8.35 4.04005L9.84 5.53005C10.51 5.24005 11.23 5.07005 12 5.07005C15.04 5.07005 17.5 7.53005 17.5 10.5701V11.0701H19C20.66 11.0701 22 12.4101 22 14.0701C22 15.0601 21.52 15.9201 20.79 16.4701L22.2 17.8801C23.29 16.9601 24 15.6101 24 14.0701ZM4.41 2.93005L3 4.34005L5.77 7.11005H5.35C2.34 7.43005 0 9.98005 0 13.0701C0 16.3801 2.69 19.0701 6 19.0701H17.73L19.73 21.0701L21.14 19.6601L4.41 2.93005ZM6 17.0701C3.79 17.0701 2 15.2801 2 13.0701C2 10.8601 3.79 9.07005 6 9.07005H7.73L15.73 17.0701H6Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CloudOff;
